<template>

  <div class="card">
    <div class="card-body">
      <p class="card-title">Upload a JSON file to update a schema </p>
      <p>Note that only adding and removing fields is allowed during update.</p>
      <b-form-row>
        <b-col>
          <b-form-file
            v-model="currentFile"
            @change="resetDialog"
            :state="null"
            class="text-truncate"
            placeholder="choose file or drop here..."
            drop-placeholder="drop file..."
            style="width: 600px"
          ></b-form-file>
        </b-col>
        <b-col>
          <b-button
            variant="primary"
            :disabled="!currentFile || loading"
            @click="upload"
          >
            <b-spinner
              v-if="loading"
              small
            ></b-spinner>
            {{ buttonLabel }}
          </b-button>
        </b-col>
      </b-form-row>
      <b-form-row v-if="currentFile">
        <b-col>
          <b-form-file
            v-model="currentChangeTableFile"
            @change="resetDialog"
            :state="null"
            class="text-truncate"
            placeholder="(optional) choose change table file..."
            drop-placeholder="drop file..."
            style="width: 600px"
          ></b-form-file>
        </b-col>
      </b-form-row>
      <p v-if="loading">
        Note: Updating the schema might take up to several minutes depending on the size of the file...
      </p>
      <b-row v-if="updateResult && updateResult.updateIssues">
        <b-col>
          <b-alert
            class="mt-1"
            variant="success"
            :show="updateResult.success"
          >Sucessfully updated schema. items with the following warnings:
          </b-alert>
          <b-alert
            class="mt-1"
            variant="danger"
            :show="!updateResult.success"
          >Import failed with the following errors and warnings:
          </b-alert>

          <b-table
            hover
            :items="formatedItems"
            :fields="fields"
            striped
            responsive="sm"
            class="m-2"
          >
          </b-table>

        </b-col>
      </b-row>
    </div>
  </div>

</template>

<script>

import { BackendApiService } from '../services/BackendApiService'

export default {
  name: 'schema-update',
  data () {
    return {
      currentFile           : undefined,
      currentChangeTableFile: undefined,
      loading               : false,
      updateResult          : {},

      fileInfos: [],
      fields   : [{
        key  : 'type',
        label: ''
      }, {
        key  : 'message',
        label: 'Message'
      }]
    }
  },
  computed: {
    formatedItems () {
      if ( !this.updateResult.updateIssues ) return []
      return this.updateResult.updateIssues.map(item => {
        item._rowVariant = item.error ? 'danger' : 'warning'
        item.type        = item.error ? 'ERROR' : 'WARN'
        return item
      })
    },

    buttonLabel () {
      if ( this.loading ) {
        return 'Updating Schema...'
      } else {
        return 'Update Schema'
      }
    }
  },
  methods : {
    resetDialog () {
      this.loading      = false
      this.updateResult = {}
    },
    upload () {
      this.loading = true

      BackendApiService.updateSchema(this.currentFile, this.currentChangeTableFile, event => {
      })
        .then(response => {
          console.log('received response')
          console.log(response)
          this.updateResult = response.data
          this.loading      = false
          console.log('success= ' + this.updateResult.success)
        })
        .catch((e) => {
          console.log('catched error ' + e)
          this.errorMessage           = e.response.data.message
          this.currentFile            = undefined
          this.currentChangeTableFile = undefined
        })
    }
  },
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SchemaUpdate.vue